module.exports = __webpack_public_path__ + "static/Chicory7-6917b643f0cc423f26e77ab5efb81a2e.png";